import React from 'react';

function footerComponent() {
    return (
        <section className="silverback-footer">
            <footer>
                <p className="mb-0">© 2021 · <a href="http://host4vip.com/" className="footer-link-silverbackhosts"> Host4vip.com </a> <span>|</span> <a href="http://host4vip.com/terms-of-use" className="text-white"> All Rights Reserved </a></p>
            </footer>
        </section>
    );
}

export default footerComponent;